import React, { useState } from "react";
import { Button, TextInput, Label, Alert } from "flowbite-react";
import {useAuth} from '../../hooks/AuthContext';
import { useNavigate } from "react-router-dom";
import LoadingSpinner from '../../components/LoadingSpinner';
import api, { API_URL, getAssetUrl } from '../../lib/api';


const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const { setPermissions, logout, setAuth } = useAuth();
    const navigate = useNavigate();
        const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        setIsLoading(true);
          
        setError(null);

        try {
            const response = await api.post(
                `/login`, 
                {
                email,
                password,
                });

            if (response.data.success) {
                //console.log("Permisos",response.data.permissions.length);
                if(response.data.permissions.length == 0){
                    logout();
                    navigate('/');  
                    return;
                }
                setAuth({ permissions: response.data.permissions });
                //localStorage.setItem("TokenPortal",response.data.token);
                localStorage.setItem("User",JSON.stringify(response.data.userData));
                localStorage.setItem("permissions", JSON.stringify(response.data.permissions));
                setPermissions(response.data.permissions);
                let userData = response.data.userData;
                try{
                    const response = await api.post(
                        `/userlog/create`,
                        {
                            user_id: userData.id,
                            origin: "LOGIN",
                            data: null
                        }
                    );
                    
                    if (!response.statusText == "OK") {
                        const data = await response.json();
                        setError(data.message);
                        //throw new Error(data.message || 'Error en la obtención de datos');
                    }
                    
                    //setBeareas(response.data);
                    
                } catch (err) {
                    setError(err.message);
                    setIsLoading(false);
                    navigate('/app');
                }

                navigate('/app');
            } else {
                setError(response.data.message || "Usuario o clave incorrecto");
                localStorage.setItem("User","");
                setIsLoading(false);
                navigate('/');
            }
        } catch (err) {

            //console.log(err.response.data.message?.original?.code);
            console.log(err.message);
            setIsLoading(false);
            setError(("Ocurrio un error en la conexión a la Base de datos")) ;
        } finally{
            setIsLoading(false);
          }
          
    };

    const handleLoginWithGoogle = () => {
        // Redirige a la ruta del servidor Node.js para autenticarse
        window.location.href = `${API_URL}/auth/google`;
    };

    return (
        <>
            {isLoading && <LoadingSpinner message="Procesando..." size="lg" color="blue"/>}
            <div className="flex items-center justify-center min-h-screen bg-gray-100">
                <form
                    onSubmit={handleSubmit}
                    className="p-6 bg-white rounded shadow-md w-full max-w-md">   
                    <div className="container mx-auto">
                        <img src={getAssetUrl('logo_exxis.png')} className="mx-auto h-6 sm:h-9" alt="Exxis Logo" />
                    </div>
                    <h1 className="text-2xl font-bold text-center mb-4">Ingreso al portal</h1>
        
                    {error && <Alert color="failure">{error}</Alert>}
        
                    <div className="mb-4">
                    <Label htmlFor="email">Email</Label>
                    <TextInput
                        id="email"
                        type="email"
                        placeholder="Ingrese email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    </div>
        
                    <div className="mb-4">
                    <Label htmlFor="password">Password</Label>
                    <TextInput
                        id="password"
                        type="password"
                        placeholder="Ingrese clave"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    </div>
        
                    <Button type="submit" className="w-full text-gray-800" color="gray">Login</Button>
                    <Button
                        onClick={handleLoginWithGoogle}
                        className="w-full text-gray-800 mt-2"  color="teal"
                    >
                        Continuar con cuenta corporativa
                    </Button>
                </form>
            </div>
        </>
        
    );
};

export default Login;
